import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import TableTreeModal from "./TableTreeModal";
import { useTableContext } from "../../context/TableContext";
import ButtonActionIcon from "./ButtonActionIcon";
import CodeEditor from "./CodeEditor/CodeEditor";

import "./CustomJs.css";
// import { toastSuccess } from "../../utils/toastUtils";

const CustomJS = ({
  editorId = "editor",
  inputString,
  handleChange,
  tableID,
  table_type = "statemachine",
  label = "Write Custom JS",
  onlyFieldId = true,
  showFullScreenIcon = true,
  height = "70vh",
  readOnly = false
}) => {
  // const [customJsInputString, setCustomJsInputString] = useState()
  const [isFieldModalOpen, setIsFieldModalOpen] = useState({
    type: "",
    valueID: ""
  });
  // const [randomValues, setRandomValues] = useState({});
  const [fieldList, setFieldsList] = useState({}); // fieldRef will not cause render, so code editor need it to load data.

  const editableRef = useRef(null);
  const cursorPositionRef = useRef(null);
  const { getTableTypeData } = useTableContext();
  const fieldsObject = useRef({});
  const [showCodeEditor, setShowCodeEditor] = useState(false);
  const [isFullScreenModalOpen, setIsFullScreenModalOpen] = useState(false);

  const fetchTableData = async () => {
    const { tableObject, fieldIDObject } = await getTableTypeData(table_type, tableID);
    fieldsObject.current = { ...fieldsObject.current, ...fieldIDObject, ...tableObject };
    setFieldsList((prevValues) => ({ ...prevValues, ...fieldIDObject, ...tableObject }));
  };

  const createSpanTagWithRandomID = (id) => {
    const newRandomValue = generateRandomValue();
    const spanElement = document.createElement("span");
    spanElement.id = newRandomValue;
    spanElement.contentEditable = false;
    spanElement.textContent = fieldsObject.current[id]?.display;
    spanElement.onclick = () => handleChangeField(newRandomValue);
    spanElement.classList.add("field_span_tag");
    return spanElement;
  };

  const closeFieldModal = () => {
    setIsFieldModalOpen({
      type: "",
      valueID: ""
    });
    listener("");
  };

  const closeFullScreenModal = () => {
    setIsFullScreenModalOpen(false);
  };

  const openFullScreenModal = () => {
    setIsFullScreenModalOpen(true);
  };

  const listener = (id) => {
    const htmlContent = editableRef.current.innerHTML;

    let spanElement = "";
    if (id) {
      spanElement = createSpanTagWithRandomID(id);
    }

    const replacedContent = htmlContent.replace(/```/, id ? spanElement.outerHTML : "");
    editableRef.current.innerHTML = replacedContent;

    if (cursorPositionRef.current !== null) {
      moveCursorToEnd();
    }
    // if (id) {
    //   setRandomValues((prevValues) => ({
    //     ...prevValues,
    //     [spanElement.getAttribute("id")]: id
    //   }));
    // }
  };

  const generateRandomValue = (prefix = "PREFIX-") => {
    const randomValue = Math.random().toString(36).substr(2, 8);
    return `${prefix}${randomValue}`;
  };

  const moveCursorToEnd = () => {
    const editableElement = editableRef.current;

    if (editableElement) {
      const range = document.createRange();
      const selection = window.getSelection();

      // Set the range to the end of the editable content
      range.selectNodeContents(editableElement);
      range.collapse(false); // Collapse the range to the end
      selection.removeAllRanges();
      selection.addRange(range);
    }
  };

  // const getDataFromEditable = () => {
  //   const editableElement = editableRef.current;

  //   if (editableElement) {
  //     let updatedString = "";

  //     const traverseNodes = (node) => {
  //       node.childNodes.forEach((childNode) => {
  //         if (childNode.nodeType === Node.TEXT_NODE) {
  //           updatedString += childNode.textContent;
  //         } else if (childNode.nodeType === Node.ELEMENT_NODE) {
  //           if (childNode.tagName.toLowerCase() === "span") {
  //             const spanId = childNode.getAttribute("id");
  //             if (spanId && randomValues[spanId]) {
  //               updatedString += `#${randomValues[spanId]}#`;
  //             }
  //           } else if (childNode.tagName.toLowerCase() === "div") {
  //             updatedString += "\n";
  //             traverseNodes(childNode);
  //           } else if (childNode.tagName.toLowerCase() === "br") {
  //             updatedString += "\n";
  //           }
  //         }
  //       });
  //     };
  //     traverseNodes(editableElement);

  //     // Convert special characters like &nbsp; to actual symbols
  //     const tempElement = document.createElement("div");
  //     tempElement.innerHTML = updatedString;
  //     // updatedString = tempElement.innerText; //dont remove this line
  //     return updatedString;
  //   }
  // };

  const targetSpaneAndUpdateContent = (spanId, dataId) => {
    const spanToUpdate = document.getElementById(spanId);
    spanToUpdate.textContent = fieldsObject.current[dataId].display;
  };

  const handleSMField = (data) => {
    let fieldID;
    if (onlyFieldId) {
      const fieldIDs = data.id.split(".");
      fieldID = fieldIDs[fieldIDs.length - 1];
    } else {
      fieldID = data.id;
    }
    setIsFieldModalOpen({
      type: "",
      valueID: ""
    });
    if (isFieldModalOpen.type === "add") {
      listener(fieldID);
    }
    if (isFieldModalOpen.type === "edit") {
      // setRandomValues((prevValues) => {
      //   const newValues = { ...prevValues };
      //   newValues[isFieldModalOpen.valueID] = fieldID;
      //   return newValues;
      // });
      targetSpaneAndUpdateContent(isFieldModalOpen.valueID, fieldID);
    }
  };

  const handleChangeField = (randomKey) => {
    setIsFieldModalOpen({
      type: "edit",
      valueID: randomKey
    });
  };

  // const copyToClipboard = (text) => {
  //   const textarea = document.createElement("textarea");
  //   textarea.value = text;
  //   document.body.appendChild(textarea);
  //   textarea.select();
  //   document.execCommand("copy");
  //   document.body.removeChild(textarea);
  //   toastSuccess("Text copied to clipboard!");
  // };

  useEffect(() => {
    fetchTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editorId, showCodeEditor]);

  const memoizedHandleChange = useCallback(
    (val) => {
      handleChange(val);
    },
    [handleChange]
  );

  //eslint-disable-next-line
  const memoizedFieldList = useMemo(() => fieldList, [JSON.stringify(fieldList)]);

  let editor = null;
  editor = Object.keys(fieldList).length && (
    <CodeEditor
      height={height}
      value={inputString}
      fieldObj={memoizedFieldList}
      tableID={tableID}
      handleChange={memoizedHandleChange}
      enableBacktickTrigger={!readOnly}
      readOnly={readOnly}
    />
  );

  useEffect(() => {
    if (isFullScreenModalOpen && showCodeEditor === false) {
      setShowCodeEditor(true);
    }
  }, [isFullScreenModalOpen, showCodeEditor]);

  return (
    <div className="rich_text_editor ">
      <div className="d_flex space_between pb_1">
        {label && <label className="builder_label">{label}</label>}
        <div className="d_flex align_center gap_3 ml_auto">
          {/* <ButtonActionIcon type="content_copy" title="Copy" onClick={() => copyToClipboard(getDataFromEditable())} /> */}
          {showFullScreenIcon && (
            <ButtonActionIcon type="fullscreen" title="Fullscreen" onClick={openFullScreenModal} />
          )}
        </div>
      </div>

      {editor}

      {!readOnly && (
        <>
          <BuilderModal isOpen={isFieldModalOpen.type} onClose={closeFieldModal} modalName="Select Field">
            <TableTreeModal callbackFunction={handleSMField} tableId={tableID} />
          </BuilderModal>
          <BuilderModal
            isOpen={isFullScreenModalOpen}
            onClose={closeFullScreenModal}
            modalName="Custom Js"
            bodyStyle={{ width: "86vw", height: "74vh" }}
            customStyleClsName="customjs_full_screen"
          >
            {Object.keys(fieldList).length && (
              <CodeEditor
                height="70vh"
                value={inputString}
                fieldObj={memoizedFieldList}
                tableID={tableID}
                handleChange={memoizedHandleChange}
                enableBacktickTrigger={true}
              />
            )}
          </BuilderModal>
        </>
      )}
    </div>
  );
};

export default CustomJS;
